export const colors = {
  home: {
    primary: '#601337',
    secondary: '#7A1846',
    light: '#E0B4C9',
    bold: '#470E29'
  },
  formation: {
    primary: '#14A8CC',
    secondary: '#17BDE6',
    light: '#CCF5FF',
    bold: '#008FB2'
  },
  news: {
    primary: '#C04635',
    secondary: '#D94F3C',
    light: '#F2D9D5',
    bold: '#A63C2E'
  },
  devotion: {
    primary: '#661B14',
    secondary: '#802219',
    light: '#E5BBB8',
    bold: '#4D140F'
  },
}